import type { FC } from "react";
import { useCallback, useState } from "react";
import { CustomerNoteFields } from "./CustomerNoteFields";

interface Props {
  readonly disabled?: boolean;
  readonly onSubmit?: (text: string, noteType: string | null) => Promise<void>;
}

export const CustomerNoteInput: FC<Props> = ({ onSubmit, disabled }) => {
  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [text, setText] = useState("");
  const [noteType, setNoteType] = useState<string | null>(null);

  const handleSubmit = useCallback(async () => {
    if (!onSubmit) {
      return;
    }
    try {
      setFieldsDisabled(true);
      await onSubmit(text, noteType);
      setText("");
      setNoteType(null);
    } finally {
      setFieldsDisabled(false);
    }
  }, [noteType, onSubmit, text]);

  const inputDisabled = disabled || fieldsDisabled;
  return (
    <CustomerNoteFields
      disabled={inputDisabled}
      noteType={noteType}
      text={text}
      onNoteTypeChange={setNoteType}
      onTextChange={setText}
      onSubmit={onSubmit ? handleSubmit : undefined}
    />
  );
};

CustomerNoteInput.displayName = "CustomerNoteInput";
